"use client";

import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { signIn, useOrganizations, useSession } from "@/lib/auth-client";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Home() {
  const { t } = useTranslation();
  const { data: session, isPending } = useSession();
  const { data: organizations } = useOrganizations();
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      !isPending &&
      session?.user &&
      organizations?.length &&
      organizations.length > 0
    ) {
      router.push(`/org/${organizations[0].slug}/dashboard`);
    }
  }, [
    session?.user,
    organizations?.length,
    organizations?.[0]?.slug,
    isPending,
  ]);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      await signIn.social({
        provider: "cognito",
        callbackURL: "/",
      });
    } catch (error) {
      console.error(t("login.failed"), error);
      setIsLoading(false);
    }
  };

  if (isPending || session?.user) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-xl w-full text-center space-y-8 p-8">
        <div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            {t("welcome.title")}
          </h1>
        </div>

        <div className="space-y-4">
          <Button
            onClick={handleLogin}
            disabled={isLoading}
            className="w-full py-3 text-lg"
            size="lg"
          >
            {isLoading ? (
              <span className="flex items-center">
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t("auth.signin.connecting")}
              </span>
            ) : (
              t("auth.signin.oauth")
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
